import type { Kombonamn } from 'src/components/rörelse';

export type Presentationsslug = 'autopilot' | 'handelser' | 'bank' | 'styrelsen' | 'mitt-hem';

/** Vilket motiv sidan bär. Indexsidan ritar samma motiv i miniatyr som kort. */
export type Motiv = 'ring' | 'banor' | 'ström' | 'kedja' | 'blomning';

export type Presentation = {
    slug: Presentationsslug;
    /** Rubriken bär sin egen tyngd. Ingen etikett ovanför. */
    titel: string;
    ingress: string;
    /** Kortare mening till metadata och indexkortet. */
    beskrivning: string;
    kombo: Kombonamn;
    motiv: Motiv;
};

export const PRESENTATIONER: Presentation[] = [
    {
        slug: 'autopilot',
        titel: 'Föreningen på autopilot',
        ingress:
            'Löpande bokföring, bokslut, årsredovisning och föreningens skyldigheter mot Skatteverket hänger ihop i ett system. Det enda som blir kvar åt dig är att signera.',
        beskrivning:
            'Bokföring, bokslut, årsredovisning och myndighetsärenden i ett sammanhängande år.',
        kombo: 'blå',
        motiv: 'ring'
    },
    {
        slug: 'handelser',
        titel: 'Allt som kommer in blir en händelse',
        ingress:
            'Fakturor, avtal, ansökningar och uppsägningar landar i samma flöde. Varje aktör legitimerar sig med BankID, och varje hushåll får sin avi.',
        beskrivning: 'Dokument, aktörer och avier i ett händelsestyrt flöde med BankID i mitten.',
        kombo: 'lila',
        motiv: 'banor'
    },
    {
        slug: 'bank',
        titel: 'Varje krona hör till något',
        ingress:
            'Föreningens konton på ett ställe, och varje banktransaktion knuten till den affärshändelse den hör till. Inget står oförklarat.',
        beskrivning: 'Flera konton, ett flöde, och en koppling från varje transaktion till sin affärshändelse.',
        kombo: 'grön',
        motiv: 'ström'
    },
    {
        slug: 'styrelsen',
        titel: 'Mötet som skriver sitt eget protokoll',
        ingress:
            'Ledamöterna lägger sina ämnen före mötet. Under mötet fattas besluten, efter det signeras protokollet med BankID och arkiveras.',
        beskrivning: 'Från kallelse till signerat protokoll, med ämnen som samlas in i förväg.',
        kombo: 'blå',
        motiv: 'kedja'
    },
    {
        slug: 'mitt-hem',
        titel: 'Ditt hem, och kvarteret omkring det',
        ingress:
            'Värme, el och spotpris, planlösning och dokumentation för just din bostad — och kanalerna, chattarna och offerterna som binder ihop de boende.',
        beskrivning: 'Bostadens egna siffror och ytor, och grannskapet runt omkring.',
        kombo: 'grön',
        motiv: 'blomning'
    }
];

export function hittaPresentation(slug: Presentationsslug): Presentation {
    const träff = PRESENTATIONER.find((p) => p.slug === slug);
    if (!träff) throw new Error(`Okänd presentation: ${slug}`);
    return träff;
}

export function grannar(slug: Presentationsslug): { föregående: Presentation; nästa: Presentation } {
    const i = PRESENTATIONER.findIndex((p) => p.slug === slug);
    const antal = PRESENTATIONER.length;
    return {
        föregående: PRESENTATIONER[(i - 1 + antal) % antal],
        nästa: PRESENTATIONER[(i + 1) % antal]
    };
}
